import { render } from "./recordHistory.vue?vue&type=template&id=60ff7f32"
import script from "./recordHistory.vue?vue&type=script&lang=js"
export * from "./recordHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__